import store from '../store/store'

/**
 * Gets 1 product per language and grade
 * @param pagePublications {array}
 * @param language {string}
 * @returns {array}
 * @constructor
 */
export function getUniquePageProducts(pagePublications, language)
{
    let publications = _.filter(pagePublications, (a) => a.language === language);
    publications = _.orderBy(publications, 'grade')
    publications = _.uniqBy(publications, 'grade')

    return publications;
}

export function getNewSocialStudiesPublications(statePublications, language)
{
    let page = store.getters.getPageByKey('social-studies');
    if (!page.filters.length)
        return defaultNewSocialStudiesPublications(statePublications, language);

    return getUniquePageProducts(applyFilter(statePublications, page.filters), language);
}

export function getAdoptedSocialStudiesPublications(statePublications, language)
{
    let page = store.getters.getPageByKey('adopted-social-studies');
    if (!page.filters.length)
        return defaultAdoptedSocialStudiesPublications(statePublications, language);

    return getUniquePageProducts(applyFilter(statePublications, page.filters), language);
}
export function getSciencePublications(statePublications, language)
{
    let page = store.getters.getPageByKey('science');
    if (!page.filters.length)
        return defaultSciencePublications(statePublications, language);

    return getUniquePageProducts(applyFilter(statePublications, page.filters), language);
}
export function getExploreSciencePublications(statePublications, language)
{
    let page = store.getters.getPageByKey('explore-science');
    if (!page.filters.length)
        return defaultExploreSciencePublications(statePublications, language);

    return getUniquePageProducts(applyFilter(statePublications, page.filters), language);
}
export function getPreKPublications(statePublications, language)
{
    let page = store.getters.getPageByKey('prek');
    if (!page.filters.length)
        return defaultPreKPublications(statePublications, language);

    return getUniquePageProducts(applyFilter(statePublications, page.filters), language);
}
export function getSummerPublications(statePublications, language)
{
    let page = store.getters.getPageByKey('summer-ela');
    if (!page.filters.length)
        return defaultSummerPublications(statePublications, language);

    return getUniquePageProducts(applyFilter(statePublications, page.filters), language);
}
export function getHealthWellnessPublications(statePublications, language)
{
    let page = store.getters.getPageByKey('health-wellness');
    if (!page.filters.length)
        return defaultHealthWellnessPublications(statePublications, language);

    return getUniquePageProducts(applyFilter(statePublications, page.filters), language);
}


export const filterTypes = {
    topic: 'topic',
    grade: 'grade',
    language: 'language',
    specific: 'sku',
    state: 'state',
};

export const filterMethods = {
    [filterTypes.topic]: filterByTopic,
    [filterTypes.grade]: filterByGrade,
    [filterTypes.language]: filterByLanguage,
    [filterTypes.state]: filterByState,
    [filterTypes.specific]: filterBySkus,
}


function filterByTopic(publications, filter) {
    return publications.filter((a) => {
        return a.subject.toLowerCase() === filter.topic.toLowerCase();
    });
}
function filterByGrade(publications, filter) {
    return publications.filter((a) => {
        return a.grade == filter.grade;
    });
}
function filterByLanguage(publications, filter) {
    return publications.filter((a) => {
        return a.language.toLowerCase() === filter.language.toLowerCase();
    });
}
function filterByState(publications, filter) {
    return publications.filter((a) => {
        return a.state.toLowerCase() == filter.state.toLowerCase();
    });
}
function filterBySkus(publications, filter) {
    return publications.filter((a) => {
        if (!filter.isRegex)
            return filter.sku.toLowerCase() === a.sku.toLowerCase();

        return a.sku.match(filter.sku);
    });
}


export function applyFilter(pubs, filters) {
    let orFilters = [];
    let andFilters = [];
    let blackoutFilters = [];

    // Organize filters by type
    for (let i = 0; i < filters.length; ++i) {
        if (!canUseFilter(filters[i]))
            continue;

        let filter = filters[i];
        if (filter.type === 'or') {
            orFilters.push(filter);
        } else if (filter.type === 'and') {
            andFilters.push(filter);
        }
        else if (filter.type === 'blackout') {
            blackoutFilters.push(filter);
        }
    }

    // All 'and' filters must be true for each product
    for (let i = 0; i < andFilters.length; ++i) {
        let filter = andFilters[i];
        let filterBy = filter.filterBy;
        let filterMethod = filterMethods[filterBy];

        if (!filterMethod)
            continue;

        pubs = filterMethod(pubs, filter);
    }

    // One of the 'or' filters must be true per product
    if (orFilters.length) {
        let allPubs = [];
        for (let i = 0; i < pubs.length; ++i) {
            let oneTrue = false;
            for (let j = 0; j < orFilters.length; ++j) {
                oneTrue = (
                    (orFilters[j].filterBy === filterTypes.topic && pubs[i].topic.toLowerCase() === orFilters[j].topic.toLowerCase())
                    || (orFilters[j].filterBy === filterTypes.grade && pubs[i].grade == orFilters[j].grade)
                    || (orFilters[j].filterBy === filterTypes.language && pubs[i].language.toLowerCase() === orFilters[j].language.toLowerCase())
                    || (orFilters[j].filterBy === filterTypes.state && pubs[i].state.toLowerCase() === orFilters[j].state.toLowerCase())
                    || (orFilters[j].filterBy === filterTypes.specific && pubs[i].sku.toLowerCase() === orFilters[j].sku.toLowerCase())
                );
                if (oneTrue) {
                    allPubs.push(pubs[i]);
                    break;
                }
            }
        }
        pubs = allPubs;
    }

        // Remove anything with a 'blackout' filter
    for (let i = 0; i < blackoutFilters.length; ++i) {
        let filter = blackoutFilters[i];
        let filterBy = filter.filterBy;
        let filterMethod = filterMethods[filterBy];

        if (!filterMethod)
            continue;

        // Remove any pubs that are matched by this filter
        let matchedPubs = filterMethod(pubs, filter);
        for (let j = 0; j < matchedPubs.length; ++j) {
            let pub = matchedPubs[j];
            let index = pubs.indexOf(pub);
            if (index !== -1) {
                pubs.splice(index, 1);
            }
        }
    }


    return pubs;
}
function canUseFilter(filter) {
    let isActive = !filter.hasOwnProperty('active') || filter.active;
    return isActive && canUseForState(filter) && canUseForHomeschool(filter) && canUseForSchoolYear(filter);
}
function canUseForSchoolYear(filter) {
    let selectedSchoolYear = store.getters.getCurrentSchoolYear;
    let minSchoolYear = (filter.hasOwnProperty('min_school_year') && filter.min_school_year !== null) ? filter.min_school_year : -9999;
    let maxSchoolYear = (filter.hasOwnProperty('max_school_year') && filter.max_school_year !== null) ? filter.max_school_year : 9999;

    return selectedSchoolYear >= minSchoolYear && selectedSchoolYear <= maxSchoolYear;
}
function canUseForState(filter) {
    let selectedState = store.getters.getSelectedState.toLowerCase();
    if (filter.hasOwnProperty('selected_states') && filter.selected_states != null & filter.selected_states.length > 0) {
        if (!filter.selected_states.find(x => x.state === null || x.state.toLowerCase() === selectedState)) {
            return false;
        }
    }
    return true;
}
function canUseForHomeschool(filter) {

    // Filter set to homeschool / school store only?
    if (!filter.hasOwnProperty('homeschool'))
        return true;

    if (filter.homeschool == null)
        return true;

    let isHomeschoolOnlyFilter = filter.homeschool === 1;
    let isOnHomeschoolStore = store.getters.isHomeschoolStore;
    // console.log("Is On Homeschool: ", isOnHomeschoolStore);
    if (isOnHomeschoolStore && isHomeschoolOnlyFilter)
        return true;

    return !isOnHomeschoolStore && !isHomeschoolOnlyFilter;
}


export function defaultNewSocialStudiesPublications(statePublications, language) {
    let prekRegex = /SW-EL-GE-(EN|ES)-V[0-9]/;
    let blacklistRegex = /(?:CA-[0-9]{2}-SS-(?:EN|ES)-V1)|(?:TX-[0-5]{2}-SS-(?:EN|ES)-V1)/;

    let blacklisted = [
        'CA-00-SS-EN-V1','CA-01-SS-EN-V1','CA-02-SS-EN-V1','CA-03-SS-EN-V1','CA-04-SS-EN-V1','CA-05-SS-EN-V1',
        'CA-07-SS-EN-V1','CA-08-SS-EN-V1',
        'TX-00-SS-EN-V1','TX-01-SS-EN-V1','TX-02-SS-EN-V1','TX-03-SS-EN-V1','TX-00-SS-EN-V1','TX-00-SS-EN-V1',
    ];

    let pubs = [];
    _.forEach(statePublications, publication => {
        // Check blacklist
        if (publication.sku.match(blacklistRegex) || blacklisted.indexOf(publication.sku) !== -1)
            return;

        let allowPublication = (
            (publication.topic == 'Social Studies'
                || publication.sku.match(prekRegex))
            && publication.language == language
        );

        if (allowPublication) {
            pubs.push(publication)
        }
    })

    pubs = _.orderBy(pubs, 'grade')
    pubs = _.uniqBy(pubs, 'grade')

    return pubs;

}
export function defaultAdoptedSocialStudiesPublications(statePublications, language) {
    let socialStudiesPublications = [];
    let blacklistRegex = /(?:(?:CA|TX)-[0-6]{2}-SS-(?:EN|ES)-V2)|(?:TX-06-SS-(?:EN|ES)-V1)/;

    _.forEach(statePublications, publication => {
        // Check blacklist
        if (publication.sku && publication.sku.match(blacklistRegex))
            return;

        // Check social studies
        if (
            publication.topic == 'Social Studies'
            && publication.language == language
        ) {
            socialStudiesPublications.push(publication)
        }
    })

    socialStudiesPublications = _.orderBy(socialStudiesPublications, 'grade')
    socialStudiesPublications = _.uniqBy(socialStudiesPublications, 'grade')

    return socialStudiesPublications
}
export function defaultSciencePublications(statePublications, language) {
    let sciencePublications = []

    _.forEach(statePublications, publication => {
        // Ignore Explore Science
        let exploreScienceSkuRegex = /EX-[0-9]{2}-SN-(?:EN|ES)-V[0-9]/;
        if (publication.sku.match(exploreScienceSkuRegex))
            return;

        // Check topic Science
        if (
            publication.topic == 'Science'
            && publication.language == language
        ) {
            sciencePublications.push(publication)
        }
    })

    sciencePublications = _.orderBy(sciencePublications, 'grade')
    sciencePublications = _.uniqBy(sciencePublications, 'grade')

    console.log("Science", sciencePublications)
    return sciencePublications
}
export function defaultExploreSciencePublications(statePublications, language) {
    let sciencePublications = []
    let regex = /EX-[0-9]{2}-SN-(?:EN|ES)-V[0-9]/;

    _.forEach(statePublications, publication => {
        if (publication.sku.match(regex))
            sciencePublications.push(publication)
    })

    sciencePublications = _.orderBy(sciencePublications, 'grade')
    sciencePublications = _.uniqBy(sciencePublications, 'grade')

    return sciencePublications
}
export function defaultPreKPublications(statePublications, language) {
    let publications = []
    let whiteList = /(?:SW-PK-GE-(EN|ES)-V[0-9])|(?:SW-EL-GE-(EN|ES)-V[0-9])|(?:CA-TK-GE-(ES|EN)-V[0-9])/;

    //general_education General Education
    _.forEach(statePublications, publication => {
        if (publication.sku.match(whiteList)
            && publication.language == language
        ) {
            publications.push(publication)
        }
    })

    publications = _.orderBy(publications, 'grade')
    publications = _.uniqBy(publications, 'grade')

    return publications
}
export function defaultSummerPublications(statePublications, language) {
    let publications = []
    let whiteList = /SU-[0-9]{2}-GE-(?:EN|ES)-V[0-9]/;

    _.forEach(statePublications, publication => {
        let whiteListMatch = publication.sku.match(whiteList);

        if (whiteListMatch
            && publication.language == language) {
            publications.push(publication)
        }
    })

    publications = _.orderBy(publications, 'grade')
    publications = _.uniqBy(publications, 'grade')

    return publications
}
export function defaultHealthWellnessPublications(statePublications, language) {
    let pubs = []

    //HW-03-GE-EN-V1 || NV-05-HW-EN-V1
    let regex = /(HW-[0-9a-zA-Z]{2}-GE-(?:EN|ES)-V[0-9])|([a-zA-Z]{2}-[0-9a-zA-Z]{2}-HW-(?:EN|ES)-V[0-9])/;
    _.forEach(statePublications, publication => {
        let matches = publication.sku.match(regex);
        if (matches
            && publication.language == language) {
            pubs.push(publication)
        }
    })

    pubs = _.orderBy(pubs, 'grade')
    pubs = _.uniqBy(pubs, 'grade')

    return pubs;
}